@if (errorService.isErrorPanelVisible) {
  <div class="hub-error-container">
    @if (errorService.areControlButtonsVisible) {
      <div class="control-buttons">
        <button (click)="closeErrorPanel()" style="margin-right: 5px;">Close</button>
        <button (click)="clearErrors()">Clear</button>
      </div>
    }
    <div class="error-list hub-custom-scrollbar">
      @for (err of errorService.visibleErrors; track err) {
        <div class="alert alert-danger" (close)="closeError(err)">
          <div class="error-date">{{err.timestamp?.toLocaleString('en-US')}}</div>
          <div class="error-info">
            <div class="error-message">{{err.error}}</div>
            <div class="error-detail">{{err.message}}</div>
          </div>
        </div>
      }
    </div>
  </div>
}